import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/globals.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Auth0ProviderWithHistory from "./Auth0ProviderWithHistory";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <AppProvider>
        <Auth0ProviderWithHistory>
          <App />
        </Auth0ProviderWithHistory>
      </AppProvider>
    </Router>
  </React.StrictMode>
);

// Register PWA service worker (production only)
if (typeof window !== "undefined" && process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/sw.js`).then(
      (reg) => {},
      (err) => console.warn("Service worker registration failed:", err)
    );
  });
}
